module.exports = __webpack_public_path__ + "static/img/third3_1_1.3007cec8.jpg";